import * as CONSTANTS from 'utils/constants/common';

const min = 1;

export const getSliderMarks = (left: string, right: string) => {
	const markStep = CONSTANTS.defaultRangeMax / 6;

	return Array(6)
		.fill(markStep)
		.reduce(
			(res, mark, i) => {
				return {
					...res,
					[mark * (i + 1)]: i === 5 && right ? right : '',
				};
			},
			{ [min]: left || '' },
		);
};
